export const ecommerceBulkImportArticle = {
  title: 'Ecommerce Hub: Bulk Import',
  slug: 'ecommerce-bulk-import',
  content: `Ecommerce Hub: Bulk Import

Generate product content in bulk.

1) Open Bulk Import
- Go to /marketing/ecommerce-hub#bulk-import.

2) Upload data
- Use the bulk import workflow to supply product data.

3) Review outputs
- Verify generated content before publishing.
`,
};
